<template>
    <div>
        <div class="lesson-content-frame" :class="{'container is-max-widescreen': enrollment.course.content_framed}">

            <lesson-header :component="component" :enrollment="enrollment" :outline="outline"/>

            <render-blocks :blocks="parsedBlocks" :data="enrollment.data" @saveData="saveData"/>

        </div>

        <div class="content-controls">
            <div class="columns">
                <div class="column" v-if="!enrollment.completed_at">
                    <div>
                        <b-tooltip position="is-right" type="is-white" class=" mr-4">
                            <template v-slot:content>
                                <i class="fas fa-check mr-1"></i>Data automatically saved to the cloud.
                            </template>
                            <i class="fad fa-cloud-check fa-lg"></i>
                        </b-tooltip>
                        <template v-if="enrollment.course.show_timer">
                            <i class="fas fa-circle fa-xs mr-2" style="color: red;"></i>
                            <strong>Recording Time:</strong> {{ formattedTime }}<span v-if="outline.require_min_time"> of {{ formattedMinTime }} required.</span>
                        </template>
                    </div>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-white" outlined v-if="outline.prevOutlineId" @click="$emit('goto', outline.prevOutlineId)"><i class="fas fa-arrow-left mr-3"></i>Previous</b-button>
                    <b-button type="is-white" outlined class="ml-5" v-if="outline.completed_at && outline.nextOutlineId" @click="$emit('goto', outline.nextOutlineId)">Next<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><i class="fas fa-arrow-right ml-3"></i></b-button>
                    <b-button type="is-white" outlined @click="$emit('complete')" class="ml-5" v-if="!outline.completed_at">Complete<span v-if="outline.counts.ofSection === outline.counts.totalSection"> Section</span><span v-else> Lesson</span><i class="fas fa-check ml-3"></i></b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import LessonHeader from "./LessonHeader";
    import RenderBlocks from "./RenderBlocks";
    import RenderComponent from "../RenderComponent.vue";

    export default {
        components: {RenderComponent, RenderBlocks, LessonHeader},
        props: ['enrollment', 'component', 'outline', 'time'],
        data: function() {
            return {};
        },
        computed: {
            formattedTime: function() {
                return moment.utc(this.time * 1000).format('HH:mm:ss');
            },
            formattedMinTime: function() {
                return moment.utc(this.outline.require_min_time * 60 * 1000).format('HH:mm:ss');
            },
            formattedLessonTime: function() {
                return moment.utc((this.time * 1000) + (this.outline.time * 60 * 1000)).format('HH:mm:ss');
            },
            parsedBlocks: function() {
                if (this.component && this.component.content) {
                    let content = this.component.content;
                    if (typeof content === 'string') content = JSON.parse(content);
                    return content.content;
                } else {
                    return [];
                }
            }
        },
        methods: {
            saveData(payload) {
                payload.component_id = this.component.id;
                this.$emit('saveData', payload);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .lesson-content-frame {
        position: absolute;
        top: 105px;
        left: 5rem;
        right: 4rem;
        bottom: 7rem;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: 2rem 2rem 7rem;

        overflow-x: hidden;
        overflow-y: auto;
    }

    .content-controls {
        position: absolute;
        left: 5rem;
        right: 4rem;
        bottom: 1.5rem;
        padding: 3rem 0 1rem;
        font-size: 0.85rem;

        color: white;

        strong {
            color: white;
        }
    }
</style>
